import React, { Component } from "react";
import "./index.css";

class ErrorModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    const { caption, content } = this.props;
    return (
      <div
        className="modal fade"
        id="error_show_modal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="modal-default-fadein"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Warning</h5>
              <button className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              {caption !== "profile_exist" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingTop: 20,
                  }}
                >
                  <img
                    src={require("../../../../images/error.png")}
                    width="82"
                    height="82"
                    alt="error"
                  />
                  <p
                    style={{
                      fontSize: 27,
                      padding: 10,
                      margin: 0,
                      color: "rgb(0,0,0,.65)",
                    }}
                  >
                    {caption}
                  </p>
                  <p
                    style={{ fontSize: 16, margin: 0, color: "rgb(0,0,0,.65)" }}
                  >
                    {content}
                  </p>
                  <button
                    style={{
                      width: 100,
                      background: "#f9ff66",
                      borderRadius: 20,
                      border: "none",
                      margin: 20,
                    }}
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <p
                      style={{
                        fontSize: 16,
                        margin: 10,
                        color: "rgb(0,0,0,.65)",
                      }}
                    >
                      OK
                    </p>
                  </button>
                </div>
              )}
              {caption === "profile_exist" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    paddingTop: 20,
                  }}
                >
                  <div
                    style={{
                      width: 100,
                      height: 100,
                      borderRadius: 60,
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center",
                      backgroundSize: "cover",
                      backgroundImage: `url(${
                        content.avatar_url
                          ? content.avatar_url
                          : require("../../../../assets/media/logo/avatar.png")
                      })`,
                    }}
                  ></div>
                  <p
                    style={{
                      fontSize: 27,
                      padding: 10,
                      margin: 0,
                      color: "rgb(0,0,0,.65)",
                    }}
                  >
                    {content.firstname}
                  </p>
                  <p
                    style={{
                      fontSize: 16,
                      margin: 0,
                      color: "rgb(0,0,0,.65)",
                      textAlign: "center",
                    }}
                  >
                    You are an Ecosystem member but not a {content.brand} member
                    yet. Would you like to use your EcoiD to register as a{" "}
                    {content.brand} member?
                  </p>
                  <button
                    style={{
                      width: 200,
                      background: "#f9ff66",
                      borderRadius: 20,
                      border: "none",
                      margin: 20,
                    }}
                  >
                    <p
                      style={{
                        fontSize: 16,
                        margin: 10,
                        color: "rgb(0,0,0,.65)",
                      }}
                    >
                      OK
                    </p>
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default ErrorModal;



// WEBPACK FOOTER //
// ./src/screens/Profile/components/ErrorModal/index.js